module.exports = __webpack_public_path__ + "static/media/icon-tag.1f1d7d73.svg";